import React from 'react';
import styles from './HelpoDivider.module.css';

export const HelpoDivider = () => {
  return (
    <img
      className={styles.divider}
      src="assets/drawables/hr.svg"
      alt="divider"
    />
  );
};
